import React, { useContext, useEffect, useState } from 'react'
import { Col, Container, Row, Spinner, Tab, Tabs } from 'react-bootstrap'
import { AuthContext, ThemeContext } from '../../auth';
import { HeaderWeb, SidebarComponent, TabsAkunDark, TabsDivisiDark, TabsRoleDark } from '../../components';
import { useMediaQuery } from 'react-responsive';
import { axiosAuth } from '../../api';


function Pegawai() {

    const { theme } = useContext(ThemeContext);
    const { accessToken, showSidebar } = useContext(AuthContext);
    const isMobile = useMediaQuery({ maxWidth: 1024 });
    const [listAkun, setListAkun] = useState([]);
    const [listDivisi, setListDivisi] = useState([]);
    const [listRole, setListRole] = useState([]);
    const [loading, setLoading] = useState(true);

    const retrieveAkun = () => {
        setLoading(true);
        axiosAuth.get(`/api/users`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setListAkun(res.data.data);
                setLoading(false);
            }).catch(err => {
                console.error(err);
                setLoading(false);
            })
    };

    const retrieveDivisi = () => {

        axiosAuth.get(`/api/groups`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setListDivisi(res.data.data);

            }).catch(err => {
                console.error(err)
            })
    };

    const retrieveRole = () => {

        axiosAuth.get(`/api/roles`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setListRole(res.data.data);

            }).catch(err => {

                console.error(err)
            })
    };

    useEffect(() => {
        if (accessToken !== undefined) retrieveAkun();
        if (accessToken !== undefined) retrieveDivisi();
        if (accessToken !== undefined) retrieveRole();
    }, [accessToken]);

    return (
        <div style={{
            overflowX: 'hidden',
            maxWidth: '100vw',
            backgroundColor: theme === 'light' ? '#121212' : '#FFFFFF',
            transition: '0.8s'
        }} >
            <SidebarComponent />
            <div id={theme === 'light' ? 'containerAppDark' : 'containerAppLight'}
                style={{
                    width: isMobile ? '100%' : `calc(100% - ${showSidebar ? '78px' : '190px'})`,
                    marginLeft: isMobile ? '0px' : showSidebar ? '78px' : '190px',
                    transition: '0.8s'
                }}
            >
                <div className={isMobile ? 'ms-2' : 'ms-3 me-3'}>
                    <Row>
                        <Col xs={6} lg={6} className='text-start'>
                            <h3 className='pt-4' style={{ fontFamily: 'Poppins-Medium', fontSize: isMobile ? '25px' : '38px', color: theme === 'light' ? '#FFFFFF' : '', marginBottom: '0px' }}>
                                Pegawai
                            </h3>
                        </Col>
                        <Col xs={6} lg={6} className={isMobile === false ? 'text-end my-auto' : 'text-end my-auto pt-4'}>
                            <HeaderWeb />
                        </Col>
                    </Row>
                </div>
                <br />
                <br />
                {loading ? (
                    <div
                        className='d-flex justify-content-center align-items-center'
                        style={{ height: '200px' }}
                    >
                        <Spinner animation='border' style={{ color: theme === 'light' ? '#F3C623' : '#2f4b7c' }} />
                    </div>
                ) : (
                    <div className={isMobile ? 'mx-1' : 'mx-3'}>
                        <Tabs
                            id="controlled-tab-pegawai"
                            defaultActiveKey="akun"
                            fill
                            style={{ fontFamily: 'Poppins-Regular' }}
                        >
                            <Tab eventKey="akun" title="Akun">
                                <TabsAkunDark
                                    listAkun={listAkun}
                                    listDivisi={listDivisi}
                                    listRole={listRole}
                                    retrieveRole={retrieveRole}
                                    retrieveDivisi={retrieveDivisi}
                                    retrieveAkun={retrieveAkun}
                                    accessToken={accessToken}
                                />
                            </Tab>
                            <Tab eventKey="divisi" title="Divisi">
                                <TabsDivisiDark
                                    listDivisi={listDivisi}
                                    retrieveDivisi={retrieveDivisi}
                                    accessToken={accessToken}
                                    retrieveRole={retrieveRole}
                                />
                            </Tab>
                            <Tab eventKey="role" title="Role">
                                <TabsRoleDark
                                    listRole={listRole}
                                    listDivisi={listDivisi}
                                    retrieveRole={retrieveRole}
                                    accessToken={accessToken}
                                />
                            </Tab>
                        </Tabs>
                    </div>
                )}

                <br />
                <br />
                <br />
                <br />
                <br />
            </div>
        </div>
    )
}

export default Pegawai